<template>
  <layout title="Reset Password">
    <div class="flex flex-col justify-center 2xl:pt-20 pt-0 pb-10">
      <div class="sm:mx-auto sm:w-full sm:max-w-md">
        <h2
          class="
            mt-6
            text-3xl
            font-extrabold
            leading-9
            text-center text-gray-900
            lg:text-5xl
          "
        >
          Reset Password
        </h2>
        <p class="mt-4 text-sm leading-5 text-center text-gray-600 max-w">
          or, return back to
          <inertia-link :href="$route('login')" class="link">
            login
          </inertia-link>
        </p>
      </div>

      <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div
          class="p-3 mb-3 text-sm text-gray-500 bg-primary-100"
          v-if="success"
        >
          We have e-mailed your password reset link!
        </div>

        <div
          class="
            px-4
            py-8
            bg-white
            border
            shadow
            border-gray-50
            sm:rounded-lg
            sm:px-10
          "
        >
          <form role="form" @submit.prevent="validate" method="POST">
            <div>
              <label
                for="email"
                class="block text-sm font-medium leading-5 text-gray-700"
              >
                Email Address
              </label>
              <div class="mt-3 rounded-md shadow-sm">
                <input
                  id="email"
                  type="email"
                  name="email"
                  required
                  class="w-full"
                  v-model="form.email"
                  placeholder="Email Address"
                />
              </div>
              <div class="error" v-if="errors.email">{{ errors.email }}</div>
              <div class="error" v-if="errors.g_recaptcha_token">
                {{ errors.g_recaptcha_token }}
              </div>
            </div>

            <div class="mt-6">
              <span class="block w-full rounded-md shadow-sm">
                <button type="submit" class="btn-primary w-full">
                  Send Password Reset Link
                </button>
              </span>
            </div>
          </form>
        </div>
      </div>
    </div>

    <modal :show="showCaptchaModal" @closeModal="closeCaptchaModal">
     <div class="text-center mb-5">
        <h3 class="text-xl font-extrabold text-primary-color">Security Verification</h3>
        <p class="mt-1 text text-gray-500">Please complete the challenge to continue.</p>
      </div>
      <div ref="wafCaptcha" class="flex justify-center"></div>
    </modal>
  </layout>
</template>

<script>
const layout = () => import(/* webpackChunkName: "layout" */ "../Components/Layout/layout.vue");
import { wafInertiaPost } from "../utils/waf";
import Modal from "../Components/modal.vue";
export default {
  components: { layout, Modal },
  props: {
    errors: Object,
  },
  data() {
    return {
      form: {
        email: null,
        g_recaptcha_token: null,
      },
      success: false,
      showCaptchaModal: false,
      siteKey: process.env.MIX_RECAPTCHA_SITE_KEY,
    };
  },
  methods: {
    validate() {
      this.getRecaptchaToken();
    },
    async submit() {
      await wafInertiaPost(this.$inertia, "/password/email", this.form, {
        onSuccess: () => {
          this.showCaptchaModal = false;
          this.success = true;
        },
        onError: () => {
          this.showCaptchaModal = false;
        },
      }, this.$refs.wafCaptcha, () => {
        this.showCaptchaModal = true;
      }, () => {
        this.showCaptchaModal = false;
      });
    },
    getRecaptchaToken() {
      let _this = this;
      if (typeof grecaptcha === 'undefined' || !this.siteKey) {
        this.submit();
        return;
      }
      grecaptcha
        .execute(this.siteKey, {
          action: "password_reset",
        })
        .then(function (token) {
          _this.form.g_recaptcha_token = token;
          _this.submit();
        })
        .catch(function () {
          _this.submit();
        });
    },
    closeCaptchaModal() {
      this.showCaptchaModal = false;
      if (this.$refs.wafCaptcha) this.$refs.wafCaptcha.innerHTML = '';
    },
  },
};
</script>


